import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import SwitchButton from 'modules/shift_management/components/ShiftManagement/SwitchButton'
import { useCurrentViewOptions } from 'modules/shift_management/hooks/useCurrentViewOptions'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { EmployeeOptions } from 'modules/shift_management/store/internal/models/ViewOptions'

interface Props {
  onChange: (option: keyof EmployeeOptions) => void
}

const EmployeeOptionsContent = ({ onChange }: Props) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const hasPlanningBalanceEnabled = hasFeatureFlag('dev_time_planning_balances_in_shifts')
  const hasBankOfHoursEnabled = hasFeatureFlag('dev_time_planning_bank_of_hours')
  const { viewOptions } = useCurrentViewOptions()
  const { employee } = viewOptions
  const {
    showJobPosition,
    showContractHours,
    showPlannedHours,
    showAvatar,
    showRole,
    showPlanningBalance,
    showBankOfHours,
  } = employee

  return (
    <>
      <Box paddingBottom="s8" paddingLeft="s12" paddingRight="s12" paddingTop="s12">
        <Text className="text-f1-foreground-secondary" weight="medium" size="100">
          {i18n.t('shift_management.view_options.titles.new_employee')}
        </Text>
      </Box>
      <Box paddingBottom="s12" paddingLeft="s12" paddingRight="s12" paddingTop="s8" gap="s16">
        {hasPlanningBalanceEnabled && (
          <SwitchButton
            onChange={() => onChange('showAvatar')}
            checked={showAvatar}
            id="showAvatar"
            title={i18n.t('shift_management.view_options.avatar')}
          />
        )}
        {hasPlanningBalanceEnabled ? (
          <>
            <SwitchButton
              onChange={() => onChange('showRole')}
              checked={showRole}
              id="showRole"
              title={i18n.t('shift_management.view_options.role')}
            />
            <SwitchButton
              onChange={() => onChange('showPlanningBalance')}
              checked={showPlanningBalance}
              id="showPlanningBalance"
              title={i18n.t('shift_management.view_options.planning_balance')}
            />
            {hasBankOfHoursEnabled && (
              <SwitchButton
                onChange={() => onChange('showBankOfHours')}
                checked={showBankOfHours}
                id="showBankOfHours"
                title={i18n.t('shift_management.view_options.bank_of_hours')}
              />
            )}
          </>
        ) : (
          // TODO: All these and related logic to be removed when the feature flag is removed
          <>
            <SwitchButton
              onChange={() => onChange('showJobPosition')}
              checked={showJobPosition}
              id="showJobPosition"
              title={i18n.t('shift_management.view_options.jobPosition')}
            />
            <SwitchButton
              onChange={() => onChange('showContractHours')}
              checked={showContractHours}
              id="showContractHours"
              title={i18n.t('shift_management.view_options.contractHours')}
            />
            <SwitchButton
              onChange={() => onChange('showPlannedHours')}
              checked={showPlannedHours}
              id="showPlannedHours"
              title={i18n.t('shift_management.view_options.plannedHours')}
            />
          </>
        )}
      </Box>
    </>
  )
}

export default observer(EmployeeOptionsContent)
